// extracted by mini-css-extract-plugin
export default {"specification":"Specification_specification__j8c2J"};